<template>
  <div>
    <div class="page_title">患教文章库</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchBox">

          <div class="item">
            <span class="title">标题</span>
            <div class="item-content">
              <el-input v-model="searcForm.title"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"></el-input>
            </div>
          </div>

          <div class="item">
            <span class="title">编辑时间</span>
            <div class="item-content">
              <el-date-picker v-model="searcForm.editTime"
                              size="small"
                              type="daterange"
                              align="right"
                              unlink-panels
                              value-format="yyyy-MM-dd"
                              range-separator="至"
                              start-placeholder="开始时间"
                              end-placeholder="结束时间"
                              @change="getList">
              </el-date-picker>
            </div>
          </div>

          <div class="item">
            <span class="title">类型</span>
            <div class="item-content"
                 style="padding-top:2px">
              <el-radio-group v-model="searcForm.status"
                              size="small"
                              @change="getList">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">待发布</el-radio>
                <el-radio :label="2">已发布</el-radio>
                <el-radio :label="3">已下架</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div class="item">
            <el-button type="primary"
                       size="small"
                       @click="getList">查询</el-button>
            <el-button size="small"
                       type="primary"
                       icon="el-icon-plus"
                       @click="toAddEssay"
                       style="width:120px">添加文章</el-button>
          </div>

        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%;min-width:1000px;"
                    :header-cell-style="{background:'#F5F5F5'}">
            <el-table-column label="标题"
                             prop="title"></el-table-column>
            <el-table-column label="作者"
                             prop="author"></el-table-column>
            <!-- <el-table-column label="正文"
                             prop="content">
              <template slot-scope="scope">
                <div v-html="scope.row.content"></div>
              </template>
            </el-table-column> -->
            <el-table-column label="编辑时间"
                             prop="update_time"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status==1">待发布</span>
                <span v-if="scope.row.status==2">已发布</span>
                <span v-if="scope.row.status==3">已下架</span>
              </template>
            </el-table-column>
            <el-table-column label="医生分享量"
                             prop="doctor_share"></el-table-column>
            <el-table-column label="患者分享量"
                             prop="user_share"></el-table-column>
            <el-table-column label="引用量"
                             prop="quote_num"></el-table-column>
            <el-table-column>
              <template slot="header">
                <span>阅读量</span>
                <el-tooltip class="item"
                            effect="light"
                            content="实际阅读量（虚拟阅读量）"
                            placement="top">
                  <el-button type="text"
                             icon="el-icon-question"></el-button>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div>{{ scope.row.real_read_num }}({{scope.row.read_num}})</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="edit(scope.row.art_id,scope.row.status)"
                           type="text"
                           size="medium">详情</el-button>
                <el-button @click="editStatus(scope.row.art_id,3)"
                           type="text"
                           size="medium"
                           v-if="scope.row.status==2">下架</el-button>
                <el-button @click="editStatus(scope.row.art_id,2)"
                           type="text"
                           size="medium"
                           v-if="scope.row.status==3||scope.row.status==1">发布</el-button>
                <el-button @click="delexample(scope.row.art_id)"
                           type="text"
                           size="medium">删除</el-button>
              </template>
            </el-table-column>

            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-button @click="updateSort(scope.$index,1)"
                           size="medium"
                           type="text"
                           icon="el-icon-upload2"
                           style="font-size:20px"></el-button>

                <el-button @click="updateSort(scope.$index,2)"
                           size="medium"
                           type="text"
                           icon="el-icon-download"
                           style="font-size:20px"></el-button>

                <el-button @click="updateSort(scope.$index,3)"
                           size="medium"
                           type="text"
                           icon="el-icon-top"
                           style="font-size:20px"></el-button>
                <el-button @click="updateSort(scope.$index,4)"
                           size="medium"
                           type="text"
                           icon="el-icon-bottom"
                           style="font-size:20px"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <pagination v-show="totalNum>0"
                  :total="totalNum"
                  :page.sync="pagination.page"
                  :limit.sync="pagination.pageNumber"
                  @pagination="getList" />
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      searcForm: {
        title: '',
        status: 0,
        editTime: ''
      },
      detail: {},
      tableData: [],
      title: this.$route.query.title
    };
  },

  methods: {
    //获取列表
    getList() {
      let params = Object.assign({}, this.pagination, this.searcForm);
      params = _.omit(params, ['editTime']);
      params['start_time'] = this.searcForm.editTime
        ? this.searcForm.editTime[0]
        : '';
      params['end_time'] = this.searcForm.editTime
        ? this.searcForm.editTime[1]
        : '';
      this.axios
        .post('platform/library/getArticlesOnPatientEducationList', params)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = platform.timestampToTime(item.update_time);
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //排序
    updateSort(index, status) {
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (status == 1) {
        this.tableData.splice(0, 0, data);
      }
      //置底
      if (status == 2) {
        this.tableData.push(data);
      }
      //上移
      if (status == 3) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (status == 4) {
        this.tableData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.tableData.map((item) => {
        item = _.pick(item, ['art_id', 'sort']);
        return item;
      });
      this.axios
        .post('platform/library/editArticlesOnPatientEducationSort', { list })
        .then((res) => {
          if (res.code == 0) {
            this.getList();
          }
        });
    },
    //添加
    toAddEssay() {
      this.$router.push('addEssay');
    },
    //编辑
    edit(art_id, status) {
      if (status == 2) {
        this.$router.push({
          path: 'essayDetail',
          query: {
            art_id
          }
        });
      } else {
        this.$router.push({
          path: 'addEssay',
          query: {
            art_id
          }
        });
      }
    },
    //修改状态
    editStatus(art_id, status) {
      this.axios
        .post('platform/library/changeArticlesOnPatientEducationStatus', {
          art_id,
          status
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('已修改发布状态');
            this.getList();
          }
        });
    },
    //删除
    delexample(art_id) {
      this.$confirm('确定要删除吗？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.axios
          .post('platform/library/deleteArticlesOnPatientEducationInfo', {
            art_id
          })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.addbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.searchBox {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .title {
      margin-right: 6px;
    }
    .item-content {
      .el-input {
        width: 160px;
      }
      .el-date-editor {
        width: 220px;
      }
    }
  }
}
</style>

